// @flow
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actions as CourierFlowActions } from '../duck';
import CourierFlow from '../components/CourierFlow';

import type { RootState } from '../../../../index';

function mapStateToProps(state: RootState) {
  return {
    locale: state.locale,
    order: state.order.order,
    itemTrackingNumberLoadingMap: state.order.purchase.courierFlow.itemTrackingNumberLoadingMap,
    itemTrackingNumberErrorMap: state.order.purchase.courierFlow.itemTrackingNumberErrorMap,
    motives: state.report.motives,
  }
}

function mapDispatchToProps(dispatch: Function) {
  return bindActionCreators(CourierFlowActions, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(CourierFlow);



// WEBPACK FOOTER //
// ./src/modules/order/Purchase/courier-flow/containers/CourierFlowContainer.jsx